<template>
  <v-dialog
    v-model="value"
    transition="dialog-bottom-transition"
    max-width="600"
    persistent
  >
    <v-card>
      <v-card-title class="headline white">
        {{ $t('components.stripeTermsConditions.title') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <p>
              {{ dialogText }}
            </p>
            <p>
              <a href="https://stripe.com/connect-account/legal" class="link" target="_blank">
                {{ $t('components.stripeTermsConditions.link') }}
              </a>
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="dialog-actions justify-end">
        <v-btn
          v-if="showCancel"
          text
          @click="onCancelClick"
        >{{ $t('misc.cancel') }}</v-btn>
        <v-btn
          color="success"
          @click="onAgreeClick"
        >{{ $t('misc.continue') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'StripeConditionsDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    onAgreeCallback: {
      type: Function,
      required: false,
    },
    bodyCopy: {
      type: String,
      required: false,
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    async onAgreeClick() {
      this.value = false;
      this.$emit('input', this.value);
      this.$emit('onAgree');

      if (this.onAgreeCallback) {
        await this.onAgreeCallback();
      }
    },
    async onCancelClick() {
      this.value = false;
      this.$emit('input', this.value);
      this.$emit('onCancel');
    },
  },
  computed: {
    dialogText() {
      if (this.bodyCopy) {
        return this.bodyCopy;
      }
      return this.$t('components.stripeTermsConditions.consoleBannerCopy');
    },
  },
};
</script>

<style scoped lang="scss">
.link {
  color: #247DFF;
}
.dialog-actions {
  padding: 16px;
}
</style>
